import { Suspense, useEffect, useState } from "react";
import { WCSLoading, WCSType } from "../../../db/model";
import { GetWcsDataAPI } from "../../../db/apiCalls";
import WcsComponent from "./WCS/WcsComponent";
import { toast } from "react-toastify";
import ErrorBoundary from "../../../ErrorBoundary";

function WorkContractRegister() {
  const [wcsData, setWcsData] = useState<WCSType[]>(WCSLoading);

  async function getWcsData() {
    let result = await GetWcsDataAPI();

    const data = result
      ? JSON.parse(result)
      : {
          statusCode: 0,
          message:
            "Something went wrong, Please check your internet connection.",
          success: false,
          workContracts: [],
        };

    if (data.success) {
      let wcsarray: WCSType[] = data.workContracts;
      return wcsarray;
    } else {
      toast.error(
        `Error fetching WCS Data, ${data.statusCode} : ${data.message}`
      );
      return [];
    }
  }

  useEffect(() => {
    getWcsData().then((data) => {
      setWcsData(data);
    });
  }, []);

  return (
    <ErrorBoundary>
      <Suspense fallback={<h3>Loading...</h3>}>
        {/* <div className="text-end w-full sticky top-0">
          <Link
            to="/orders/new-order"
            className="bg-blue-600 text-white justify-center border-0 rounded-lg py-1 px-3"
          >
            <NoteAddIcon fontSize="small" className="mb-1 my-auto" /> Add
          </Link>
        </div> */}
        <WcsComponent wcsData={wcsData} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default WorkContractRegister;
